import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { supabase } from '../lib/supabase';

const STORAGE_LIMIT_MB = 100; // 100MB制限
const WARNING_THRESHOLD = 0.8; // 80%で警告

interface StorageState {
  totalSize: number; // bytes
  isLoading: boolean;
  error: string | null;
  calculateStorageSize: () => Promise<void>;
  checkStorageLimit: () => {
    isOverLimit: boolean;
    isNearLimit: boolean;
    usedPercentage: number;
    remainingMB: number;
  };
}

export const useStorageStore = create<StorageState>()(
  persist(
    (set, get) => ({
      totalSize: 0,
      isLoading: false,
      error: null,

      calculateStorageSize: async () => {
        try {
          set({ isLoading: true, error: null });

          // Get all files from storage
          const { data: files, error } = await supabase
            .storage
            .from('analysis-data')
            .list();

          if (error) throw error;

          // Calculate total size
          const totalSize = files?.reduce((acc, file) => acc + (file.metadata?.size || 0), 0) || 0;
          set({ totalSize });

        } catch (err) {
          console.error('Error calculating storage size:', err);
          set({ error: 'ストレージサイズの計算に失敗しました' });
        } finally {
          set({ isLoading: false });
        }
      },

      checkStorageLimit: () => {
        const { totalSize } = get();
        const limitBytes = STORAGE_LIMIT_MB * 1024 * 1024;
        const usedPercentage = (totalSize / limitBytes) * 100;
        const remainingBytes = limitBytes - totalSize;
        const remainingMB = Math.floor(remainingBytes / (1024 * 1024));

        return {
          isOverLimit: totalSize >= limitBytes,
          isNearLimit: totalSize >= limitBytes * WARNING_THRESHOLD,
          usedPercentage: Math.min(100, Math.round(usedPercentage)),
          remainingMB: Math.max(0, remainingMB),
        };
      },
    }),
    {
      name: 'sprint-analysis-storage',
      storage: createJSONStorage(() => localStorage),
    }
  )
);